import { Minus, Plus } from "lucide-react";
import React, { useState } from "react";

function AskedQuestion({ item }) {
	const [isOpened, setIsOpened] = useState(false);

	return (
		<div>
			{isOpened && (
				<div className="pt-6 px-2 pb-4">
					<div
						className="flex items-center justify-between pb-4 cursor-pointer"
						onClick={() => {
							setIsOpened(!isOpened);
						}}
					>
						<div className="text-xl font-semibold">{item.question}</div>
						<Minus />
					</div>
					<div className="border border-[#E2E8F0] rounded-[10px] p-4">{item.answer}</div>
				</div>
			)}
			{!isOpened && (
				<div
					className="flex items-center justify-between border-y border-y-[#E2E8F0] py-6 cursor-pointer"
					onClick={() => {
						setIsOpened(!isOpened);
					}}
				>
					<div className="text-xl font-semibold">{item.question}</div>
					<Plus />
				</div>
			)}
		</div>
	);
}

export default AskedQuestion;
